export const visit = (vm, at) => {
at({ "pl": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Masz problem z obejrzeniem tego filmu?", "playButton": "Odtw\xF3rz" } } });
};